import axios from "axios";
import app from "./main";

const instance = axios.create({
  baseURL: process.env.VUE_APP_API
});

instance.interceptors.request.use(
  reqConfig => {
    //app.$Progress.start();
    reqConfig.headers.authorization =
      "Bearer " + localStorage.getItem("accessToken");

    if (reqConfig.url.includes("/logout")) {
      reqConfig.headers["X-REFRESH-TOKEN"] = localStorage.getItem(
        "refreshToken"
      );
    }

    return reqConfig;
  },
  err => Promise.reject(err)
);

let isFetchingToken = false;
let tokenSubscribers = [];

function subscribeTokenRefresh(cb) {
  tokenSubscribers.push(cb);
}
function onTokenRefreshed(errRefreshing, token) {
  tokenSubscribers.map(cb => cb(errRefreshing, token));
}

function forceLogout() {
  isFetchingToken = false;
  localStorage.clear();

  window.location = "/login";
}

instance.interceptors.response.use(
  response => {
    //app.$Progress.finish();
    return response;
  },
  err => {
    //app.$Progress.fail();
    if (err.response.config.url.includes("/token")) return Promise.reject(err);
    if (err.response.status === 403) return forceLogout();
    if (err.response.status !== 401) return Promise.reject(err);

    if (!isFetchingToken) {
      isFetchingToken = true;

      const refreshToken = localStorage.getItem("refreshToken");
      if (!refreshToken) return forceLogout();

      instance
        .post("/token", {
          grantType: "refreshToken",
          refreshToken: refreshToken
        })
        .then(response => {
          isFetchingToken = false;

          onTokenRefreshed(null, response);
          tokenSubscribers = [];

          localStorage.setItem("accessToken", response.data.accessToken);
        })
        .catch(() => {
          onTokenRefreshed(new Error("Unable to refresh access token"), null);
          tokenSubscribers = [];

          forceLogout();
        });
    }
    return new Promise((resolve, reject) => {
      subscribeTokenRefresh((errRefreshing, newToken) => {
        if (errRefreshing) return reject(errRefreshing);

        err.config.headers.authorization =
          "Bearer " + newToken.data.accessToken;
        return resolve(axios(err.config));
      });
    });
  }
);

export default instance;
